import { add, format } from "date-fns";
import moment from "moment";
export const toLocalDateTimeString = (date: string, formatString: string = "yyyy-MM-dd h:mm a") => {
  return format(Date.parse(date), formatString);
};

export const toOffsetDateTimeString = (
  date: string,
  options: {
    offset?: number;
    label?: string;
    formatString?: string;
    appendLabel?: boolean;
  }
) => {
  const o = { offset: 0, label: "", formatString: "yyyy-MM-dd h:mm a", appendLabel: true, ...options };
  const unspecifiedTzDate = date.replace("Z", "");
  return `${format(add(Date.parse(unspecifiedTzDate), { hours: o.offset }), o.formatString)}${
    o.appendLabel && o.label ? ` ${o.label}` : ""
  }`;
};

const dateTimeMappings = {
  toLocalDateTimeString,
  toOffsetDateTimeString,
};

export const dateInPast = (date: Date) => {
  if(!date) return false;
   var now = new Date();
   var diff = new Date(date).valueOf() - now.valueOf();
   return diff < 0
}

export const dateWithin90Mins = (date: Date) => {
  if(!date) return false;
  var now = new Date();
  var diff = new Date(date).valueOf() - now.valueOf();
  if (diff < 0) return false;
  else {
    return (diff/1000)/60 <= 90; 
  }
}
export default dateTimeMappings;
